export const getPublishAnalysis = (info, analysis) => [
  { id: 1, title: analysis.articles_count, subtitle: 'Articles' },

  {
    id: 2,
    title: info.journals_count,
    subtitle: 'Recognized journals'
  },

  {
    id: 3,
    title: info.subject_areas_count,
    subtitle: 'Subject areas'
  },

  {
    id: 4,
    title: info.publishers_count,
    subtitle: 'Publishers'
  }
]

export const getInfoBoxes = (data, format, currency) => [
  {
    id: 1,
    title: data.published_oa_count,
    subtitle: 'OA articles published'
  },

  {
    id: 2,
    title: data.articles_with_apc_costs_count,
    subtitle: 'Articles with APC costs'
  },

  {
    id: 3,
    title: data.average_apc_cost ? format(+data.average_apc_cost) : 'N/A',
    subtitle: `Average APC cost (${currency})`
  },

  {
    id: 4,
    title: data.total_apc_cost ? format(+data.total_apc_cost) : 'N/A',
    subtitle: `Total APC cost (${currency})`
  }
]
